// extracted by mini-css-extract-plugin
export default {"notifier":"NotificationContext_notifier__pEapo","notification":"NotificationContext_notification__QW6fF"};